import { start } from "./main.ts";

start();
